/**
 * Validates a UUID v4 license code
 * Accepts formats like:
 *  - 123e4567-e89b-12d3-a456-426614174000
 *  - 123E4567-E89B-12D3-A456-426614174000
 *  - Optional: without hyphens 123e4567e89b12d3a456426614174000
 *
 * @param {string} code - The license code to validate
 * @returns {boolean} - true if valid, false otherwise
 */
export const isValidLicenseCode = (code) => {
  if (!code || typeof code !== "string") return false;

  const normalized = code.trim().toLowerCase();

  // UUID v4 regex definition
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  const uuidNoHyphenRegex = /^[0-9a-f]{32}$/;

  return uuidRegex.test(normalized) || uuidNoHyphenRegex.test(normalized);
};